<template>
  <ul class="header-list">
      <li v-for="item in detailNavList" :key="item.title" :class="item.tab === selectTab ? 'on' : ''">
        <em class="tit" @click="checkTab(item)">{{item.title}}</em>
      </li>
  </ul>
</template>

<script>
export default {
  props: {
    detailNavList: Array,
    pageTab: String
  },
  data() {
    return {
      selectTab: this.pageTab
    }
  },
  watch: {
    pageTab(nv, ov){
      nv !== ov ? this.selectTab = nv : ''
    }
  },
  methods: {
    checkTab(item) {
      this.selectTab = item.tab
      this.$emit("chooseTab", this.selectTab);
    }
  }
};
</script>

<style>
.header-list li{
  float: left;
  position: relative;
  color: #808695;
  height: 32px;
  line-height: 32px;
}
.header-list li.on .tit{
  color: #2d8cf0;
}
.header-list li .tit {
  cursor: pointer;
  padding-right: 20px;
}

.header-list li + li .tit{
  padding-left: 20px;
}
.header-list li + li .tit::before{
  content: '';
  display: block;
  width: 1px;
  height: 12px;
  background-color: #E8EAEC;
  position: absolute;
  left: 0;
  top: 10px;
}
</style>